import React, { Dispatch, SetStateAction, useContext, useState } from "react";
import Dialog from "../../../../ui/widgets/dialog";
import { useMessageSource } from "react-message-source";
import CustomTypography from "../../../../ui/widgets/typography";
import { Product } from "../../../../context/product-context/product";
import ProductSelection from "../../../../ui/widgets/product-selection";
import { ProductRefType } from "../../../../context/product-context/types";
import { ProductContext } from "../../../../context/product-context/productContext";
import CustomIconButton from "../../../../ui/widgets/button-icon";
import { ProductFamilySelectionContent } from "../../../home/product-family-selection-modal/product-family-selection-content";
import { BootstrapperContext } from "../../../../context/bootstrapperContext";
import NavigationBar from "../../../../ui/layout/page/content/footer/navigation-bar";
import ContentFooter from "../../../../ui/layout/page/content/footer";

enum Step {
  FAMILY_SELECTOR,
  PRODUCT_SELECTOR,
}

interface StartApplicationDialogProps {
  startBasicAccountApplication: (productRef: ProductRefType) => Promise<void>;
  isActive: boolean;
  setIsActive: Dispatch<SetStateAction<boolean>>;
}

const noop = () => {
  // no-operation
};

export const StartApplicationDialog = ({
  startBasicAccountApplication,
  setIsActive,
  isActive,
}: StartApplicationDialogProps): React.JSX.Element => {
  const [step, setStep] = useState<Step | null>(Step.FAMILY_SELECTOR);
  const [localSelectedProduct, setLocalSelectedProduct] = useState<Product>();
  const { getMessage } = useMessageSource();
  const { families } = useContext(BootstrapperContext);
  const { findProduct } = useContext(ProductContext);

  const familySelectorContent = (
    <>
      <div className="scd-dialog-header">
        <CustomTypography variant="h2">
          {getMessage("ProductFamily.title")}
        </CustomTypography>
        <CustomIconButton
          onClick={() => setIsActive(false)}
          title="Close"
          icon="close"
        />
      </div>
      <ProductFamilySelectionContent
        handleOnProductFamilySelection={(product: Product) => {
          setStep(Step.PRODUCT_SELECTOR);
          setLocalSelectedProduct(product);
        }}
        families={families}
        handleDialogClose={noop}
      />
    </>
  );

  const productSelectorContent = (
    <>
      <div className="scd-dialog-header">
        <CustomTypography variant="h2">
          {getMessage("ProductOffer")}
        </CustomTypography>
        <CustomIconButton
          onClick={() => setIsActive(false)}
          title="Close"
          icon="close"
        />
      </div>

      <ProductSelection
        selectedProduct={localSelectedProduct}
        onSelectCallback={(value: ProductRefType) => {
          setLocalSelectedProduct(findProduct(value));
        }}
      />

      <ContentFooter>
        <NavigationBar
          onBack={() => {
            setStep(Step.FAMILY_SELECTOR);
          }}
          onNext={() => {
            startBasicAccountApplication(localSelectedProduct.productRef);
          }}
          backButtonText={getMessage("Onboarding.back")}
          nextButtonText={getMessage(
            "Dashboard.basicAccountApplicationOpen.button-text",
          )}
        />
      </ContentFooter>
    </>
  );

  return (
    <Dialog maxWidth="lg" open={isActive}>
      {step === Step.FAMILY_SELECTOR && familySelectorContent}
      {step === Step.PRODUCT_SELECTOR && productSelectorContent}
    </Dialog>
  );
};
